import React, { useState } from "react";
import SiteHeader from "@/components/common/SiteHeader";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useExternalAuthCodeQuery } from "@/queries/queries";
import { DateTime } from "luxon";
import { getLocalStorageAuth, updateLocalStorageAuth } from "@/lib/utils";

const AuthSuccess = () => {
  const [didSuccess, setDidSuccess] = useState<boolean>(false);
  const { code = "", isTest = false } = useSearch({
    from: "/external/auth_success",
  });

  const currentAuth =
    getLocalStorageAuth("coned", "con_ed_ny") ||
    getLocalStorageAuth("coned", "orange_and_rockland_utilities");

  const { isSuccess } = useExternalAuthCodeQuery(code, currentAuth, isTest);
  if (isSuccess && !didSuccess) {
    // TODO: FIX FOR ORU, not just ConEd
    updateLocalStorageAuth("coned", "con_ed_ny", {
      status: "SUCCESS",
      updated_on: DateTime.now().toISOTime(),
    });
    setDidSuccess(true);
  }

  return (
    <div className="flex flex-col w-full">
      <SiteHeader header="Authorization Success" />
      <div className="px-10 py-8">
        <div>
          You have successfully authorized Carbon Clear to access your utility
          data. Your energy consultant will contact you with next steps!
        </div>
      </div>
    </div>
  );
};

type AuthSuccessSearch = {
  code?: string;
  isTest?: boolean;
};
export const Route = createFileRoute("/external/auth_success")({
  component: AuthSuccess,
  validateSearch: (search: Record<string, string>): AuthSuccessSearch => ({
    code: search?.code ? String(search?.code) : undefined,
    isTest: search?.isTest ? Boolean(search?.isTest) : undefined,
  }),
});
